const state = {
    selectedPayment: null
};

const getters = {
    GET_SELECTED_PAYMENT: state => {
        return state.selectedPayment;
    }
};

const actions = {
    CLEAR_PAYMENT_STORE: ({ commit }) => {
        commit("clearStore");
    },

    SET_SELECTED_PAYMENT: ({ commit }, selectedObj) => {
        commit("saveSelectedPayment", selectedObj);
    }
};

const mutations = {
    saveSelectedPayment: (state, selectedObj) => {
        state.selectedPayment = selectedObj;
    },

    clearStore: state => {
        state.selectedPayment = null;
    }
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}